import { create } from 'zustand';
import { BookingDate, Slot, SlotConsultant, Session, Appointment } from '../types';

interface BookingState {
  // Dates
  dates: BookingDate[];
  selectedDate: BookingDate | null;
  
  // Slots
  slots: Slot[];
  selectedSlot: Slot | null;
  selectedConsultant: SlotConsultant | null;
  
  // Session
  session: Session | null;
  
  // Appointment
  appointment: Appointment | null;
  
  // Loading states
  loadingDates: boolean;
  loadingSlots: boolean;
  startingSession: boolean;
  
  // Actions
  setDates: (dates: BookingDate[]) => void;
  setSelectedDate: (date: BookingDate | null) => void;
  setSlots: (slots: Slot[]) => void;
  setSelectedSlot: (slot: Slot | null) => void;
  setSelectedConsultant: (consultant: SlotConsultant | null) => void;
  setSession: (session: Session | null) => void;
  setAppointment: (appointment: Appointment | null) => void;
  setLoadingDates: (loading: boolean) => void;
  setLoadingSlots: (loading: boolean) => void;
  setStartingSession: (loading: boolean) => void;
  
  // Reset functions
  resetSlotSelection: () => void;
  resetAll: () => void;
}

export const useBookingStore = create<BookingState>((set) => ({
  // Initial state
  dates: [],
  selectedDate: null,
  slots: [],
  selectedSlot: null,
  selectedConsultant: null,
  session: null,
  appointment: null,
  loadingDates: false,
  loadingSlots: false,
  startingSession: false,
  
  // Actions
  setDates: (dates) => set({ dates }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  setSlots: (slots) => set({ slots }),
  setSelectedSlot: (slot) => set({ selectedSlot: slot }),
  setSelectedConsultant: (consultant) => set({ selectedConsultant: consultant }),
  setSession: (session) => set({ session }),
  setAppointment: (appointment) => set({ appointment }),
  setLoadingDates: (loading) => set({ loadingDates: loading }),
  setLoadingSlots: (loading) => set({ loadingSlots: loading }),
  setStartingSession: (loading) => set({ startingSession: loading }),
  
  // Reset functions
  resetSlotSelection: () => set({ 
    slots: [], 
    selectedSlot: null, 
    selectedConsultant: null,
    session: null,
    appointment: null
  }),
  
  resetAll: () => set({
    dates: [],
    selectedDate: null,
    slots: [],
    selectedSlot: null,
    selectedConsultant: null,
    session: null,
    appointment: null,
    loadingDates: false,
    loadingSlots: false,
    startingSession: false,
  }),
}));
